<script src="https://s.pageclip.co/v1/pageclip.js" charset="utf-8"></script>
<main>
<section>
	<h1>Monkey Hire .</h1>
	<h3>A platform to connect bands and musicans with venues and events</h3>

	<form action="https://send.pageclip.co/0GVthoZ1gWdcJRIZi9GXaMqVfBhtmrmC" class="pageclip-form" method="post">
		<input name="email" type="email" placeholder="joe@example.com"/>
		<button type="submit"  class="pageclip-form__submit">I am intrested</button>
	</form>
	<img src="/imgs/e7e827a0f9fe79d3c85906573f64ca49.webp" alt="">
</section>
</main>

<style>


h1{
	font-weight: 900;
	font-size:5vw;
}


:global(body){
	background-color: #F0DEA7;
}
section{
	padding: 5em;

}
img{
	width: 40%;
	left: 55%;
	bottom: 0;
	position: absolute;
}

input{
	border-radius: 5px;
	padding: 10px;
	height: 3em;
	width: 40%;
	border: none;
	display: block;
}


button{
	margin-top: 2%;
	display: block;
	height: 3em;
	width: 20%;
	border-radius: 10px;
	background-color: #F9BF0E;
	color: white;
	stroke: black;
	stroke-width: 5px;
	font-weight: bold;
	font-size: 1em;
}

@media (max-width: 1020px) {

img{
display: block;
width: 60%;
left: 40%;
}

h1{
	font-size: 4em;
}

section{
	padding: 2em;
}

input{
	width: 60%;
}
}
@media (max-width: 790px) {

	img{
display: block;
width: 60%;
left: 40%;
}

h1{
font-size: 4em;
}

section{
padding: 2em;
}

input{
width: 70%;
}
button{
	width: 30%;
}
}

</style>
